// import React from 'react'
// import { Link } from 'react-router';
// import Header from '../Header';
// import Sidebar from '../Sidebar';

// export default function EditOrder() {
//          const handleSubmit = (e) => {
//     e.preventDefault();
//   };

//   return (
//   <div id="dashboard-root" 
//                 className="flex min-h-[1000px] w-full">
//                   {/* <!-- Sidebar --> */}
//                   <Sidebar />
//                   {/* <!-- Main Content --> */}
//                   <main id="main-content" className="flex-1 px-10 py-8">
//                     {/* <!-- Header --> */}
//             <Header title="Edit Order" />
//             <form onSubmit={handleSubmit}>
//               <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6 p-8 bg-white">
//                       <div class="mb-4">
//                           <label class="block text-sm font-medium text-gray-700 mb-1">Category Name</label>
//                           <input type="text" class="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" />
//                       </div>
//                       <div class="mb-4">
//                           <label class="block text-sm font-medium text-gray-700 mb-1">Parent Category (Optional)</label>
//                           <select class="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500">
//                               <option>None</option>
//                               <option>Medications</option>
//                               <option>Devices</option>
//                               <option>Supplements</option>
//                               <option>First Aid</option>
//                           </select>
//                       </div>
//                       <div class="mb-4">
//                           <label class="block text-sm font-medium text-gray-700 mb-1">Description</label>
//                           <textarea rows="3" class="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500"></textarea>
//                       </div>
//                       <div class="mb-4">
//                           <label class="block text-sm font-medium text-gray-700 mb-1">Icon</label>
//                           <div class="grid grid-cols-6 gap-2 mt-2">
//                               <button type="button" class="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center hover:bg-primary-50 hover:text-primary-600">
//                                   <i class="fa-solid fa-capsules"></i>
//                               </button>
//                               <button type="button" class="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center hover:bg-primary-50 hover:text-primary-600">
//                                   <i class="fa-solid fa-pills"></i>
//                               </button>
//                               <button type="button" class="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center hover:bg-primary-50 hover:text-primary-600">
//                                   <i class="fa-solid fa-tablets"></i>
//                               </button>
//                               <button type="button" class="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center hover:bg-primary-50 hover:text-primary-600">
//                                   <i class="fa-solid fa-prescription-bottle"></i>
//                               </button>
//                               <button type="button" class="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center hover:bg-primary-50 hover:text-primary-600">
//                                   <i class="fa-solid fa-stethoscope"></i>
//                               </button>
//                               <button type="button" class="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center hover:bg-primary-50 hover:text-primary-600">
//                                   <i class="fa-solid fa-syringe"></i>
//                               </button>
//                               <button type="button" class="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center hover:bg-primary-50 hover:text-primary-600">
//                                   <i class="fa-solid fa-band-aid"></i>
//                               </button>
//                               <button type="button" class="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center hover:bg-primary-50 hover:text-primary-600">
//                                   <i class="fa-solid fa-heart-pulse"></i>
//                               </button>
//                               <button type="button" class="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center hover:bg-primary-50 hover:text-primary-600">
//                                   <i class="fa-solid fa-kit-medical"></i>
//                               </button>
//                           </div>
//                       </div>
//                       <div class="mb-4">
//                           <label class="block text-sm font-medium text-gray-700 mb-1">Status</label>
//                           <div class="flex items-center space-x-4">
//                               <label class="flex items-center">
//                                   <input type="radio" name="status" class="mr-2 text-primary-600" checked="" />
//                                   <span>Active</span>
//                               </label>
//                               <label class="flex items-center">
//                                   <input type="radio" name="status" class="mr-2 text-primary-600" />
//                                   <span>Inactive</span>
//                               </label>
//                           </div>
//                       </div>
//                       <div class="border-t pt-4 flex justify-end space-x-3">
//                            <Link to="/orders" class="px-4 py-2 border border-gray-300 rounded-lg text-gray-700" id="cancel-category-modal">Cancel</Link>
//                           <button type="submit" class="px-4 py-2 bg-primary-600 text-white rounded-lg">Submit</button>
//                       </div>
//                       </div>
//                   </form>
//                   </main>
//       </div>
//   )
// }


import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebar";
import Header from "../Header";
import { useLocation, useNavigate } from "react-router-dom";
import { useOrderStore } from "../../store/useOrderStore";
import Loader from "../loader/Loader";
import ProductDetailsTable from "../ProductDetailsTable";





const EditOrder = () => {
    const navigate = useNavigate()
    const [id, setId] = useState('')
    const [order, setOrder] = useState({})
    const [user, setUser] = useState({})
    const [loading, setLoading] = useState(false)
    const [productDetails, setProductDetails] = useState([])
    const [orderStatus, setOrderStatus] = useState('')

    const location = useLocation();
    const { getOrderById, updateOrderStatus } = useOrderStore()

    const handleOrderStatusChange = (newStatus) => {
        setOrderStatus(newStatus)
    };

    const getOrderByIdFunction = async (id) => {
        try {
            setLoading(true)
            const res = await getOrderById(id)
            if (res) {
                setOrder(res?.ref)
                setUser(res?.user)
                setProductDetails(res?.productDetails)
                setOrderStatus(res?.ref?.orderStatus)
            }
            setLoading(false)
        } catch (error) {
            console.log(error)
            setLoading(false)
        }
    }

    const handleSubmit = async () => {
        try {
            setLoading(true)
            await updateOrderStatus(id, orderStatus)
            setLoading(false)
        } catch (error) {
            console.log(error)
            setLoading(false)
        }
    }

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const id = params.get("id");
        setId(id)
        getOrderByIdFunction(id)
    }, [location.search])
    return (
        <div className="p-[10px]">
            <div id="dashboard-root"
                className="flex min-h-[1000px] w-full">
                <Loader loading={loading} />
                {/* <!-- sidebar --> */}
                <Sidebar />
                {/* <!-- Main Content --> */}
                <main id="main-content" className="flex-1 px-10 py-8">
                    {/* <!-- Header --> */}
                    <Header title="Order Summary" />
                    <div className="max-w-5xl mx-auto p-6 bg-white rounded-2xl shadow-md space-y-6 text-sm text-gray-700">
                        {/* Order Summary */}
                        {/* <h2 className="text-2xl font-bold text-gray-900">Order Summary</h2> */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <Detail label="Order ID" value={order?.orderId} />
                            <Detail label="Database ID" value={order?._id} />
                            <Detail label="Payment Status" value={order?.paymentStatus} />

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Order Status</label>
                                <select
                                    value={orderStatus}
                                    onChange={(e) => handleOrderStatusChange(e.target.value)}
                                    className={`mt-1 block w-half px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 sm:text-sm
      ${orderStatus === 'Cancelled' ? 'border-red-500 text-red-700 bg-red-50 focus:ring-red-500'
                                            : orderStatus === 'Delivered' ? 'border-green-500 text-green-700 bg-green-50 focus:ring-green-500'
                                                : orderStatus === 'Shipped' ? 'border-blue-500 text-blue-700 bg-blue-50 focus:ring-blue-500'
                                                    : 'border-yellow-500 text-yellow-700 bg-yellow-50 focus:ring-yellow-500'}
    `}
                                >
                                    <option value="Processing">Processing</option>
                                    <option value="Shipped">Shipped</option>
                                    <option value="Delivered">Delivered</option>
                                    <option value="Cancelled">Cancelled</option>
                                </select>
                            </div>


                            {/* <Detail label="Is Delivered" value={order?.isDelivered ? "Yes" : "No"} /> */}
                            <Detail label="Created At" value={new Date(order?.createdAt).toLocaleString()} />
                            <Detail label="Updated At" value={new Date(order?.updatedAt).toLocaleString()} />
                            <Detail label="Total (Before Coupon)" value={`$${order?.totalAmountBeforeCoupon}`} />
                            <Detail label="Total (After Coupon)" value={`$${order?.totalAmountAfterCoupon}`} />

                        </div>

                        <div className="p-6  border-t">
                            {/* other sections like user info, order summary, etc. */}
                            <ProductDetailsTable productDetails={productDetails} />
                        </div>

                        {/* User Info */}
                        <div className="flex justify-between  border-t">
                            <div className="pt-6">
                                <h3 className="text-lg font-semibold mb-2">User Info</h3>
                                <div className="flex items-center space-x-4">
                                    <img src={user?.avatar} alt={user?.userName} className="w-16 h-16 rounded-full object-cover" />
                                    <div>
                                        <p><strong>Username:</strong> {user?.userName}</p>
                                        <p><strong>Full Name:</strong> {user?.fullName}</p>
                                        <p><strong>Email:</strong> {user?.email}</p>
                                    </div>
                                </div>
                            </div>

                            {/* Shipping Address */}
                            <div className="pt-6">
                                <h3 className="text-lg font-semibold mb-2">Shipping Address</h3>
                                <div className="space-y-1">
                                    <p><strong>Name:</strong> {order?.shippingAddress?.fullName}</p>
                                    <p><strong>Phone:</strong> {order?.shippingAddress?.phone}</p>
                                    <p><strong>Street:</strong> {order?.shippingAddress?.streetAddress}</p>
                                    <p><strong>Apartment:</strong> {order?.shippingAddress?.apartment}</p>
                                    <p><strong>City:</strong> {order?.shippingAddress?.city}</p>
                                    <p><strong>State:</strong> {order?.shippingAddress?.state}</p>
                                    <p><strong>Zip Code:</strong> {order?.shippingAddress?.zipCode}</p>
                                    <p><strong>Country:</strong> {order?.shippingAddress?.country || "N/A"}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>

            <div className="border-t mb-3 flex justify-end mr-[20px] space-x-3">
                <button
                    type="button"
                    className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700"
                    id="cancel-product"
                    onClick={() => navigate(-1)}
                >
                    Cancel
                </button>
                <button
                    onClick={handleSubmit}
                    type="submit"
                    className="px-4 py-2 bg-primary-600 text-white rounded-lg"
                >
                    Save
                </button>
            </div>
        </div>
    );
};

const Detail = ({ label, value }) => (
    <div className="flex flex-col">
        <span className="text-sm text-gray-500">{label}</span>
        <span className="text-base font-medium">{value}</span> {/* ← change this */}
    </div>
);


export default EditOrder;
